import { typographyDesktop } from '@shared/tokens/typography.desktop.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

const textareaMessageColor = (status: string) => {
  if (status === 'success') return colors.successText;
  if (status === 'error') return colors.errorText;
  return null;
};

export const styles = stylex.create({
  base: (isDisabled, status) => ({
    display: 'block',
    cursor: { default: 'pointer', ':disabled': 'not-allowed' },
    boxSizing: 'border-box',
    border: `1px solid`,
    borderRadius: anatomy.borderRadiusS,
    width: '280px',
    height: status === 'success' || status === 'error' ? '78px' : '94px',
    outline: 'none',
    backgroundColor: colors.primaryBackground,
    fontFamily: fonts.din2014Regular,
    fontSize: typographyDesktop['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: typographyDesktop['lineHeightCaption-1'],
    color: colors.primaryText,
    padding: '8px 16px',
    '::placeholder': {
      color: isDisabled ? colors.ghostText : colors.tertiaryText,
    },
    ':disabled': {
      borderColor: colors.ghostBorder,
      backgroundColor: colors.ghostBackground,
      color: colors.foregroundTertiary,
      resize: 'none',
    },
    ':disabled:hover': {
      borderColor: colors.ghostBorder,
    },
    ':read-only': {
      borderColor: colors.ghostBorder,
      color: colors.secondaryText,
    },
    ':read-only:hover': {
      borderColor: colors.ghostBorder,
    },
  }),
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  containerDisabled: {
    cursor: 'not-allowed',
  },
  aboveTextarea: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '4px',
  },
  labelMsg: (isDisabled, isReadOnly) => ({
    fontFamily: fonts.din2014Regular,
    fontSize: typographyDesktop['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: typographyDesktop['lineHeightCaption-1'],
    color: isDisabled || isReadOnly ? colors.ghostText : colors.secondaryText,
    marginRight: '4px',
  }),
  lockIcon: {
    marginLeft: 'auto',
  },
  default: {
    borderColor: colors.tertiaryBorder,
    ':hover': {
      borderColor: colors.hoverBorder,
    },
    ':focus': {
      borderColor: colors.accentBorder,
    },
  },
  success: {
    borderColor: colors.successBorder,
  },
  error: {
    borderColor: colors.errorBorder,
  },
  textareaMessage: (status) => ({
    marginTop: '4px',
    fontFamily: fonts.din2014Regular,
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '12px',
    color: textareaMessageColor(status),
  }),
});
